import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f34c6da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "with-ibk" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 과 함께합니다. ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 세금 환급 서비스 ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "더낸세금", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 무료로 신청하고 더낸세금 돌려 받으세요 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 무료 조회 ")
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))

import { ref, onMounted, onBeforeMount } from 'vue'
import { computed } from '@vue/reactivity'
import { useRoute } from 'vue-router'

import { COLOR_SET, FONT_WEIGHT } from '@/styles/variables'
import Text from '@/components/common/TextComponent.vue'
import Button from '@/components/common/Button.vue'

import { getImageUrl } from '@/utils/getImageUrl'
import { isFacebook } from '@/utils/navigator'
import toRefund from '@/utils/toRefund'

import { getTargetText, getTargetLogoUrl } from '../constants/marketings'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingMain',
  setup(__props) {

_useCssVars(_ctx => ({
  "ea8f915e": (_unref(buttonBottom)),
  "2a52898c": (_unref(tooltipBottom))
}))

const route = useRoute()
const wrapper = ref()
const marketingText = ref('')
const targetLogo = ref('')
const showAnimation = ref(false)

onMounted(() => {
  showAnimation.value = true
})

onBeforeMount(() => {
  const { utm_source } = route.query
  marketingText.value = getTargetText(utm_source?.toString() || '')
  targetLogo.value = getTargetLogoUrl(utm_source?.toString() || '')
})

const buttonBottom = computed(() => isFacebook() ? '90px' : '30px')
const tooltipBottom = computed(() => isFacebook() ? '143px' : '83px')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "wrapper"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["text-wrapper animation-show", { show: showAnimation.value }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _unref(getImageUrl)(targetLogo.value)
        }, null, 8, _hoisted_2),
        _createVNode(Text, { "mobile-size": "10px" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createVNode(Text, {
        size: "64px",
        "mobile-size": "30px",
        "line-height": "1.25",
        weight: "700",
        class: "title",
        "text-align": "center",
        "word-break": "keep-all"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(marketingText.value) + " 사업자를 위한 ", 1),
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(Text, {
        size: "28px",
        "mobile-size": "16px",
        margin: "20px 0 55px 0",
        "mobile-margin": "20px 0 0 0",
        color: _unref(COLOR_SET).blue01
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["color"])
    ], 2),
    _createVNode(Button, {
      class: _normalizeClass(["button animation-show", { show: showAnimation.value }]),
      text: "환급 신청하기",
      weight: "700",
      width: "90vw",
      "max-width": "327px",
      "font-size": "20px",
      height: "60px",
      "mobile-effect": true,
      onButton_click: _unref(toRefund)
    }, null, 8, ["class", "onButton_click"]),
    _createElementVNode("div", {
      class: _normalizeClass(["tooltip animation-show", { show: showAnimation.value }])
    }, [
      _createVNode(Text, {
        size: "12px",
        color: _unref(COLOR_SET).white,
        weight: _unref(FONT_WEIGHT).bold
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["color", "weight"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["main-img animation-show delay", { show: showAnimation.value }])
    }, [
      _createElementVNode("img", {
        src: _unref(getImageUrl)('landing/main.png')
      }, null, 8, _hoisted_9),
      _hoisted_10
    ], 2)
  ], 512))
}
}

})